import { render, staticRenderFns } from "./Profile-Bottom-review.vue?vue&type=template&id=03411e86&"
import script from "./Profile-Bottom-review.vue?vue&type=script&lang=js&"
export * from "./Profile-Bottom-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports